import { getProfileKey } from '../../authentication/selectors';
import jobs from '../../entities/jobs/actions';
import entity from '../../entities/jobs/entity';

export const TYPES = {
  CLEAR_SEARCH_JOB_TITLE: 'jobs/CLEAR_SEARCH_JOB_TITLE',
  CLEAR_JOB_TEMPLATES: 'jobs/CLEAR_JOB_TEMPLATES',
  GET_TEMPLATES_ERROR: 'jobs/GET_TEMPLATES_ERROR',
  GET_TEMPLATES_SUCCESS: 'jobs/GET_TEMPLATES_SUCCESS',
  GET_TEMPLATES: 'jobs/GET_TEMPLATES',
  GET_JOB_SUMMARY_ERROR: 'jobs/GET_JOB_SUMMARY_ERROR',
  GET_JOB_SUMMARY_SUCCESS: 'jobs/GET_JOB_SUMMARY_SUCCESS',
  GET_JOB_SUMMARY: 'jobs/GET_JOB_SUMMARY',
  LOAD_REQUEST_ERROR: 'jobs/LOAD_REQUEST_ERROR',
  LOAD_REQUEST_SUCCESS: 'jobs/LOAD_REQUEST_SUCCESS',
  LOAD_REQUEST: 'jobs/LOAD_REQUEST',
  UPDATE_FILTER_OPTIONS: 'jobs/UPDATE_FILTER_OPTIONS',
  UPDATE_SORT_OPTIONS: 'jobs/UPDATE_SORT_OPTIONS',
  UPDATE_SEARCH_QUERY: 'jobs/UPDATE_SEARCH_QUERY',
};

export const searchJobTitle = options => async (dispatch) => {
  dispatch({ type: TYPES.LOAD_REQUEST });
  try {
    const response = await dispatch(jobs.getJobTitleSearch(options));
    const { data: { content } } = response;
    const payload = content.map(job => job.id);
    dispatch({ type: TYPES.LOAD_REQUEST_SUCCESS, payload });
  } catch (error) {
    dispatch({ type: TYPES.LOAD_REQUEST_ERROR, payload: error });
  }
};

export const getJobTemplates = options => async (dispatch, getState) => {
  dispatch({ type: TYPES.GET_TEMPLATES });
  const profileKey = getProfileKey(getState());
  try {
    const response = await entity.api.getJobTemplates(options, profileKey);
    dispatch({ type: TYPES.GET_TEMPLATES_SUCCESS, payload: response?.data });
  } catch (error) {
    dispatch({ type: TYPES.GET_TEMPLATES_ERROR, payload: error });
  }
};

export const getJobSummary = organizationId => async (dispatch) => {
  dispatch({ type: TYPES.GET_JOB_SUMMARY });
  try {
    const response = await entity.api.getJobSummary(organizationId);
    const payload = response;
    dispatch({ type: TYPES.GET_JOB_SUMMARY_SUCCESS, payload });
  } catch (error) {
    dispatch({ type: TYPES.GET_JOB_SUMMARY_ERROR, payload: error });
  }
};

export const clearSearchJobTitle = (dispatch) => {
  dispatch({ type: TYPES.CLEAR_SEARCH_JOB_TITLE });
};

export const clearJobTemplate = (dispatch) => {
  dispatch({ type: TYPES.CLEAR_JOB_TEMPLATES });
};

export const updateFilterOptions = options => (dispatch) => {
  dispatch({ type: TYPES.UPDATE_FILTER_OPTIONS, payload: options });
};

export const updateSearchQuery = options => (dispatch) => {
  dispatch({ type: TYPES.UPDATE_SEARCH_QUERY, payload: options });
};

export const updateSortOptions = options => (dispatch) => {
  dispatch({ type: TYPES.UPDATE_SORT_OPTIONS, payload: options });
};

export default {
  TYPES,
  clearJobTemplate,
  clearSearchJobTitle,
  getJobTemplates,
  searchJobTitle,
  updateFilterOptions,
  updateSearchQuery,
  getJobSummary,
};
